var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "dashboard-card",
      attrs: { id: "dashboard-card-organizations" },
    },
    [
      _c("div", { staticClass: "dashboard-card-content" }, [
        _c(
          "div",
          { staticClass: "dashboard-card-title dashboard-typography" },
          [_vm._v(_vm._s(_vm.t("app-organizations")))]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "inquiries-breakdown" }, [
          _c("div", { staticClass: "inquiries-breakdown-option" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.organizationsInquiriesBreakdownOption,
                  expression: "organizationsInquiriesBreakdownOption",
                },
              ],
              attrs: {
                type: "radio",
                id: "organizations-contacted-inquiries",
                name: "organizations-inquiries",
                value: "contacted",
              },
              domProps: {
                checked: _vm._q(
                  _vm.organizationsInquiriesBreakdownOption,
                  "contacted"
                ),
              },
              on: {
                change: function ($event) {
                  _vm.organizationsInquiriesBreakdownOption = "contacted"
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              { attrs: { for: "organizations-contacted-inquiries" } },
              [
                _c(
                  "span",
                  {
                    staticClass:
                      "stat-count dashboard-typography dashboard-typography-vibrant",
                  },
                  [_vm._v(_vm._s(_vm.organizationsContactedInquiries))]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "stat-label dashboard-typography" }, [
                  _vm._v(_vm._s(_vm.t("app-contacted"))),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "inquiries-breakdown-option" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.organizationsInquiriesBreakdownOption,
                  expression: "organizationsInquiriesBreakdownOption",
                },
              ],
              attrs: {
                type: "radio",
                id: "organizations-uncontacted-inquiries",
                name: "organizations-inquiries",
                value: "uncontacted",
              },
              domProps: {
                checked: _vm._q(
                  _vm.organizationsInquiriesBreakdownOption,
                  "uncontacted"
                ),
              },
              on: {
                change: function ($event) {
                  _vm.organizationsInquiriesBreakdownOption = "uncontacted"
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              { attrs: { for: "organizations-uncontacted-inquiries" } },
              [
                _c(
                  "span",
                  {
                    staticClass:
                      "stat-count dashboard-typography dashboard-typography-vibrant",
                  },
                  [_vm._v(_vm._s(_vm.organizationsUncontactedInquiries))]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "stat-label dashboard-typography" }, [
                  _vm._v(_vm._s(_vm.t("app-uncontacted"))),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "inquiries-breakdown-option" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.organizationsInquiriesBreakdownOption,
                  expression: "organizationsInquiriesBreakdownOption",
                },
              ],
              attrs: {
                type: "radio",
                id: "organizations-total-inquiries",
                name: "organizations-inquiries",
                value: "total",
              },
              domProps: {
                checked: _vm._q(
                  _vm.organizationsInquiriesBreakdownOption,
                  "total"
                ),
              },
              on: {
                change: function ($event) {
                  _vm.organizationsInquiriesBreakdownOption = "total"
                },
              },
            }),
            _vm._v(" "),
            _c("label", { attrs: { for: "organizations-total-inquiries" } }, [
              _c(
                "span",
                {
                  staticClass:
                    "stat-count dashboard-typography dashboard-typography-vibrant",
                },
                [_vm._v(_vm._s(_vm.total))]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "stat-label dashboard-typography" }, [
                _vm._v(_vm._s(_vm.t("app-total"))),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "admin-list-table",
            class: _vm.organizationsInquiriesBreakdownOption,
          },
          [
            _c("vuetable", {
              attrs: {
                "api-mode": false,
                data: _vm.organizationsTableList,
                fields: _vm.organizationsTableFields,
                "show-sort-icons": false,
                "no-data-template": _vm.t("app-no-data-available"),
                css: { tableClass: "ui-table clickable-rows" },
              },
              on: { "vuetable:row-clicked": _vm.rowClicked },
              scopedSlots: _vm._u([
                {
                  key: "name-slot",
                  fn: function (props) {
                    return _c("div", {}, [
                      _c("div", {
                        staticClass: "table-legend",
                        style: `background: ${props.rowData.color}`,
                      }),
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.t(props.rowData.name)) +
                          "\n        "
                      ),
                    ])
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "dashboard-card-actions" },
        [
          _c("DateRangeOptions", {
            ref: "organizationsDateRange",
            attrs: {
              "disabled-dates": "afterToday",
              limits: { min: null, max: _vm.tomorrowTs },
            },
            on: {
              input: _vm.onDateRangeInput,
              active: function ($event) {
                return _vm.$emit("onDateRangeActive", { uid: _vm._uid })
              },
            },
            model: {
              value: _vm.date,
              callback: function ($$v) {
                _vm.date = $$v
              },
              expression: "date",
            },
          }),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "dashboard-action-link",
              attrs: { to: _vm.link("admin/organizations") },
            },
            [
              _vm._v(
                "\n      " + _vm._s(_vm.t("app-organizations")) + "\n      "
              ),
              _c("span", { staticClass: "material-icons" }, [
                _vm._v("navigate_next"),
              ]),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "chart-wrapper" }, [
      _c("canvas", {
        attrs: {
          id: "organizations-inquiries-chart",
          width: "400",
          height: "75",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }